"use client";
import { jsxs as b, jsx as f } from "react/jsx-runtime";
import { COLOR_SEVERITY as $ } from "../../constants/colorSeverity.js";
import { focusOutline as h } from "../mixins/focusOutline.js";
import { css as p } from "@emotion/react";
import n from "@emotion/styled";
import { COLORS as a } from "../../../tokens/colors/Colors.js";
import { FONT_SIZES as x } from "../../../tokens/font-sizes/FontSizes.js";
import { SIZES as g } from "../../../tokens/sizes/Sizes.js";
import { SPACINGS as o } from "../../../tokens/spacings/Spacings.js";
import { forwardRef as y } from "react";
const w = y(
  ({
    children: r,
    feAdornment: e,
    feControlsAfter: i,
    feControlsBefore: t,
    feHeightAuto: s = !1,
    fePaddingAll: l = !1,
    feSeverity: m,
    feSize: c,
    ...d
  }, u) => /* @__PURE__ */ b(
    I,
    {
      ...d,
      "data-comp": "input-wrapper",
      feHeightAuto: s,
      fePaddingAll: l,
      feSeverity: m,
      feSize: c,
      ref: u,
      children: [
        t && t,
        /* @__PURE__ */ f(S, { feAdornment: e, feHeightAuto: s, children: r }),
        i && i
      ]
    }
  )
);
w.displayName = "InputWrapper";
const I = n.div(
  ({ feHeightAuto: r, fePaddingAll: e, feSeverity: i, feSize: t }) => p`
		align-items: center;
		background: ${a.white};
		border: 1px solid ${i ? $[i].base : a.gray500};
		border-radius: ${g.s02};
		display: flex;
		font-size: ${t === "sm" && x.sm};
		gap: 0 ${o.sm};
		height: ${r ? "" : t === "sm" ? "2rem" : "2.75rem"};
		padding: ${e ? o.sm : `0 ${o.sm}`};

		&:has(:disabled) {
			background: ${a.gray100};
			color: ${a.gray600};
			cursor: not-allowed;
		}

		&:has(:focus-visible) {
			${h({ offset: "-1px" })}
		}
	`
), S = n.div(
  ({ feAdornment: r, feHeightAuto: e }) => p`
		flex: 1;
		height: ${!e && "100%"};
		min-width: 0;

		${r && p`
			align-items: center;
			display: flex;
			gap: 0 ${o.xxs};

			&::before,
			&::after {
				color: ${a.gray500};
				white-space: nowrap;
			}

			&::before {
				content: ${r.prefix && `'${r.value}'`};
			}

			&::after {
				content: ${!r.prefix && `'${r.value}'`};
			}
		`};

		& :where(input, textarea) {
			appearance: none;
			background-color: inherit;
			border: none;
			color: inherit;
			cursor: inherit;
			height: ${!e && "inherit"};
			margin: 0;
			padding: 0;
			width: 100%;

			&:focus-visible {
				outline: 0;
			}
		}

		input {
			/* Hides spin buttons in Firefox */
			&[type='number'] {
				appearance: textfield;
			}

			&[type='number']::-webkit-inner-spin-button,
			&[type='search']::-webkit-search-cancel-button {
				display: none;
			}
		}

		textarea {
			display: block;
		}
	`
);
export {
  w as default
};
